import React from "react";
import { Text } from "@mantine/core";
import { Display } from "@/utils/api";
import { ComponentType } from "../displayScreenTypes";

export interface RoomNameComponentProps {
  /** Room name to display */
  roomName?: string;

  /** Display data for fallback */
  display?: Display;

  /** Fallback component type if room name is not available */
  fallback?: ComponentType;

  /** Additional CSS class name for styling */
  className?: string;

  /** Inline styles */
  style?: React.CSSProperties;
}

export const RoomNameComponent: React.FC<RoomNameComponentProps> = ({
  roomName,
  display,
  fallback,
  className,
  style,
}) => {
  // If room name exists, show it
  if (roomName) {
    return (
      <Text
        className={className}
        style={{
          color: "inherit",
          fontSize: "inherit",
          fontWeight: "inherit",
          fontFamily: "inherit",
          lineHeight: "inherit",
          ...style,
        }}
      >
        {roomName}
      </Text>
    );
  }

  // If no room name and fallback is display_name, show display name
  if (fallback === "display_name" && display?.name) {
    return (
      <Text
        className={className}
        style={{
          color: "inherit",
          fontSize: "inherit",
          fontWeight: "inherit",
          fontFamily: "inherit",
          lineHeight: "inherit",
          ...style,
        }}
      >
        {display.name}
      </Text>
    );
  }

  // Nothing to show
  return null;
};
